import React from 'react'
import './index.scss'
import clsx from 'clsx'
import { SubmitButtonType } from '@App/enum/submit-button-type'

interface SubmitButtonProps {
    mainColor?: boolean
    type?: SubmitButtonType
    className?: string
    disabled?: boolean
    label: string
}

const SubmitButton = (props: SubmitButtonProps) => {
    const { mainColor = true, type = SubmitButtonType.primary, className, label, disabled } = props
    const classNames = clsx(mainColor ? 'main-color-set' : 'second-color-set', type, className, disabled && 'disabled')
    return (
        <div className={`submit-button-component ${classNames}`}>
            <input className={classNames} type="submit" value={label} disabled={disabled} />
        </div>
    )
}

export default SubmitButton
